import { useListDirectoryAddonsInfinite } from 'api/frontend-infinite';
import { useEffect, useState } from 'react';
import { flattenPages } from 'utils/arrays';

export function useAddonIdToNameMap({
  token,
}: {
  token: string;
}): Map<string, string> {
  const [result, setResult] = useState<Map<string, string>>(new Map([]));
  const { data: addonData } = useListDirectoryAddonsInfinite(
    {},
    {
      request: { headers: { Authorization: `Bearer ${token}` } },
    },
  );
  useEffect(() => {
    if (addonData) {
      setResult(
        new Map(
          (flattenPages(addonData) || []).map((c) => [c.id, c.name || '']),
        ),
      );
    }
  }, [addonData]);

  return result;
}

export function useAddonIdToDetailsMap({
  token,
}: {
  token: string;
}): Map<string, { name: string; eolSource: string | undefined }> {
  const [result, setResult] = useState<
    Map<string, { name: string; eolSource: string | undefined }>
  >(new Map([]));
  const { data: addonData } = useListDirectoryAddonsInfinite(
    {},
    {
      request: { headers: { Authorization: `Bearer ${token}` } },
    },
  );

  useEffect(() => {
    if (addonData) {
      setResult(
        new Map(
          (flattenPages(addonData) || []).map((c) => [
            c.id,
            { name: c.name || '', eolSource: c.eol_source },
          ]),
        ),
      );
    }
  }, [addonData]);

  return result;
}
